import {Modal} from 'antd'
import {useTableContext} from '../TableContext.jsx'
import TopButton from './TopButton.jsx'

const ButtonMoveRowsDown = ({children = '下移', ...props}) => {
    const table = useTableContext()

    const handleClick = () => {
        if (
            0 === table.filters.length &&
            0 === table.sorts.length
        ) {
            table.moveRowsDown(table.rowSelection?.selectedRowKeys)
        }
        else {
            Modal.error({content: '请先取消筛选和排序'})
        }
    }

    return (
        <TopButton
            minRows={1}
            onClick={handleClick}
            {...props}
        >{children}</TopButton>
    )
}

export default ButtonMoveRowsDown
